import { createBrowserRouter, Navigate } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import LoginLayout from '@/components/layout/LoginLayout'
import ProtectedRoute from '@/components/guards/ProtectedRoute'
import GuestRoute from '@/components/guards/GuestRoute'
import LoginPage from '@/pages/LoginPage'
import RegisterPage from '@/pages/RegisterPage'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage'
import ResetPasswordPage from '@/pages/ResetPasswordPage'
import { LanguageProvider } from '@/contexts/LanguageContext'
import { DEFAULT_LANGUAGE } from '@/i18n'
import { ExpiredLinkPage } from '@/pages/ExpiredLinkPage.tsx'
import ToolManagementPage from '@/pages/ToolManagementPage'
import QrCodePage from '@/pages/QRCodePage'
import SummarizationPage from '@/pages/Summarization'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to={`/${DEFAULT_LANGUAGE}`} replace />,
  },

  {
    path: '/:lang',
    element: <LanguageProvider />,
    children: [
      {
        element: (
          <GuestRoute>
            <LoginLayout />
          </GuestRoute>
        ),
        children: [
          {
            path: 'login',
            element: <LoginPage />,
          },
          {
            path: 'register',
            element: <RegisterPage />,
          },
          {
            path: 'forgot',
            element: <ForgotPasswordPage />,
          },
          {
            path: 'reset-password',
            element: <ResetPasswordPage />,
          },
          {
            path: 'expired-link',
            element: <ExpiredLinkPage />,
          },
        ],
      },

      {
        path: '',
        element: <ProtectedRoute />,
        children: [
          {
            element: <Layout />,
            children: [
              {
                index: true,
                element: <Navigate to='tool-management' replace />,
              },
              {
                path: 'tool-management',
                element: <ToolManagementPage />,
              },
              {
                path: 'qrcode',
                element: <QrCodePage />,
              },
              {
                path: 'summarization',
                element: <SummarizationPage />,
              },
            ],
          },
        ],
      },
    ],
  },

  {
    path: '*',
    element: (
      <div className='flex items-center justify-center min-h-screen'>
        <div className='text-center'>
          <h1 className='text-4xl font-bold mb-4'>404</h1>
          <p className='text-muted-foreground mb-4'>Page not found</p>
          <a
            href={`/${DEFAULT_LANGUAGE}`}
            className='text-primary hover:underline'
          >
            Go back home
          </a>
        </div>
      </div>
    ),
  },
])
